module.exports = __webpack_public_path__ + "img/UmidadeBlack.0353f4ce.svg";